// ========================================
// カレンダー関連の定数定義
// ========================================

/**
 * 曜日定義（英語）
 * カレンダーヘッダーで使用（週開始: 月曜）
 */
export const WEEKDAYS_EN = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
] as const;

/**
 * 曜日定義（日本語短縮形）
 * 日付フォーマットで使用（週開始: 月曜）
 */
export const WEEKDAYS_JP_SHORT = [
  "月",
  "火",
  "水",
  "木",
  "金",
  "土",
  "日",
] as const;

export const WEEKDAYS_EN_SHORT = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
] as const;

/**
 * 時間範囲定義
 * 24時間表示（0-23時）
 */
export const HOURS_24 = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23,
];

/**
 * カレンダーグリッドの設定
 */
export const CALENDAR_GRID = {
  DAYS_PER_WEEK: 7,
  MAX_VISIBLE_EVENTS_PER_DAY: 3,
  WEEKDAY_HEADER_HEIGHT_PX: 28,
  MIN_DAY_CELL_HEIGHT_PX: 104,
  WEEK_START_MONDAY: 1, // Monday = 1, Sunday = 0
} as const;

/**
 * イベント表示に関する設定
 */
export const EVENT_DISPLAY = {
  MAX_EVENTS_IN_DAY_CELL: 1,
  EVENT_CELL_HEIGHT: 20, // 各イベントセルの高さ（ピクセル）
  TIME_SLOT_HEIGHT: 80, // タイムスロットの高さ（ピクセル）
} as const;

/**
 * モーダルの設定
 */
export const MODAL_CONFIG = {
  MAX_WIDTH: "3xl",
  MAX_HEIGHT: "80vh",
  EVENT_DETAIL_MAX_WIDTH: "2xl",
  EVENT_DETAIL_MAX_HEIGHT: "90vh",
} as const;

export const UNIT_MINUTE = 4;
export const UNIT_HOUR = 1;
export const UNIT_DAY = 2;
export const UNIT_WEEK = 3;
export const REMINDER_TYPE_CUSTOM = 2;

export const EVENT_TYPE_STUDYGROUP_ONLY = 0;
export const EVENT_TYPE_LOUNGE_WIDE = 1;

export const EVENT_LOCATION_TYPE_ONLINE = 1;
export const EVENT_LOCATION_TYPE_OFFLINE = 2;
export const EVENT_LOCATION_TYPE_HYBRID = 3;

export const EVENT_TITLE_MAX_LENGTH = 200;
export const EVENT_DESCRIPTION_MAX_LENGTH = 65535;
export const EVENT_LOCATION_MAX_LENGTH = 128;
export const EVENT_ONLINE_LOCATION_MAX_LENGTH = 65535;

export const EVENT_REMINDER_MINUTE_MAX_VALUE = 60;
export const EVENT_REMINDER_HOUR_MAX_VALUE = 24;
export const EVENT_REMINDER_DAY_MAX_VALUE = 31;
export const EVENT_REMINDER_WEEK_MAX_VALUE = 4;

export const EVENT_IMAGE_MAX_FILE_SIZE = 5 * 1024 * 1024;

export const LANG_EN = "en-GB";
export const LANG_JP = "ja";

export const STUDYGROUP_SECRET_STR = "secret";
export const STUDYGROUP_PRIVATE_STR = "private";
export const STUDYGROUP_PUBLIC_STR = "public";
export const STUDYGROUP_VISIBILITY_SEARCH_DISABLED = 0;
export const STUDYGROUP_VISIBILITY_SEARCH_ENABLED = 1;
export const STUDYGROUP_STATUS_ENABLED = 1;
export const STUDYGROUP_JOIN_POLICY_FREE = 2;
export const STUDYGROUP_JOIN_POLICY_INVITE_AND_REQUEST = 1;
export const STUDYGROUP_JOIN_POLICY_INVITE_ONLY = 0;
export const STUDYGROUP_CONTENT_VISIBLE_PUBLIC = 1;
export const STUDYGROUP_CONTENT_VISIBLE_PRIVATE = 0;
export const STUDYGROUP_MEMBERSHIP_STATUS_INVITED = 1;
export const STUDYGROUP_MEMBERSHIP_STATUS_REQUESTING = 2;
export const STUDYGROUP_MEMBERSHIP_STATUS_MEMBER = 3;
export const STUDYGROUP_DESCRIPTION_MAX_LENGTH = 100;
export const STUDYGROUP_TITLE_MAX_LENGTH = 45;
export const STUDYGROUP_TAG_MAX_LENGTH = 20;
export const STUDYGROUP_INVITATION_MAX_LENGTH = 200;
export const STUDYGROUP_INVITE_MAX_USERS_PER_REQUEST = 50;
export const STUDYGROUP_ABOUT_MAX_LENGTH = 65535;

export const COMMENT_MAX_LENGTH = 65535;
export const COMMENT_MAX_FILE_SIZE = 200 * 1024 * 1024;
export const COMMENT_MAX_FILE_COUNT = 10;

export const POST_MAX_LENGTH = 65535;
export const POST_MAX_FILE_SIZE = 200 * 1024 * 1024;
export const POST_MAX_FILE_COUNT = 10;

export const CHAT_TITLE_MAX_LENGTH = 30;
export const CHAT_MESSAGE_MAX_LENGTH = 65535;
export const CHAT_MAX_FILE_SIZE = 50 * 1024 * 1024;
export const CHAT_MAX_FILE_COUNT = 5;

export const LINKLIST_CATEGORY_TITLE_MAX_LENGTH = 255;
export const LINKLIST_CATEGORY_DESCRIPTION_MAX_LENGTH = 255;
export const LINKLIST_TITLE_MAX_LENGTH = 255;
export const LINKLIST_URL_MAX_LENGTH = 65535;
export const LINKLIST_DESCRIPTION_MAX_LENGTH = 255;

export const FILES_DIRECTORY_TITLE_MAX_LENGTH = 255;
export const FILES_DIRECTORY_DESCRIPTION_MAX_LENGTH = 255;

export const USER_LASTNAME_MAX_LENGTH = 30;
export const USER_FIRSTNAME_MAX_LENGTH = 20;
